export enum IActionResultType {
  UpdateData = "UpdateData",
  RefreshData = "RefreshData",
  OpenForm = "OpenForm",
  OpenUrl = "OpenUrl",
  ChangeUI = "ChangeUI",
  DestroyForm = "DestroyForm",
  Script = "Script"
}
